import { LanguageDetectorAsyncModule, PostProcessorModule } from 'i18next';

import configs from '@webtrader/core/configs';
import { EProjectPlatform } from '@webtrader/core/configs/types';
import storage, { EStorageKey } from '@webtrader/core/storage';

const SEPARATOR = '::';
const PLUGIN_NAME = 'resolveMultipleTranslation';

const isNative = configs.platform === EProjectPlatform.NATIVE;

type TLangDetectorCallbackOptions = string | readonly string[] | undefined;

export const resolveMultipleTranslation: PostProcessorModule = {
  type: 'postProcessor',
  name: PLUGIN_NAME,
  process(value) {
    if (value.includes(SEPARATOR)) {
      return value.split(SEPARATOR)[1];
    }
    return value;
  }
};

export const overloadTranslationOptionHandler = (args: string[]) => {
  if (args[0]?.includes(SEPARATOR)) {
    return {
      postProcess: PLUGIN_NAME
    };
  }

  return { defaultValue: args[1] };
};

// Reference: https://github.com/0xClpz/i18next-react-native-async-storage/blob/master/index.js
export const languageDetector: LanguageDetectorAsyncModule = {
  type: 'languageDetector',
  async: true,
  init: async () => {},
  detect: (
    callback: (lng: TLangDetectorCallbackOptions) => void | undefined
  ): void | Promise<TLangDetectorCallbackOptions> => {
    if (isNative) {
      const language = storage.getItem<string>(EStorageKey.LANGUAGE);
      return callback(language || 'en_GB');
    } else {
      return callback('en_GB');
    }
  },
  cacheUserLanguage: async (language) => {
    if (isNative) {
      storage.setItem(EStorageKey.LANGUAGE, language);
    }
  }
};
